/* eslint-disable max-len */
import { Text } from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React from 'react';

import { useSelectorFeedbackUrl } from '../..../../../../../configuration';
import { useSelectorSchool } from '../..../../../../../user-profiles';
import { Button } from '../../../../components/three-essentials/button/button';
import {
    Container, Header, ContentWrapper, Title, Description, Email
} from './manage-rollover.styled';

export const ManageRollover = () => {
    const feedbackUrl = useSelectorFeedbackUrl();
    const school = useSelectorSchool();
    const schoolName = school?.name;
    const customerEmail = t`customerServiceEmail.email`;

    return (
        <Container>
            <Header>{t`manageRollover.heading`}</Header>
            <ContentWrapper>
                <Title>{t`manageRollover.title`}</Title>
                <Description>
                    <Text>{t`manageRollover.description1`}</Text>
                    <Text display={'flex'}>{t`manageRollover.description2`}:&nbsp;<Email href={`mailto:${customerEmail}?Subject=${t`customerServiceEmail.rollover`}&body=${schoolName}`}>{customerEmail}</Email></Text>
                </Description>
                <Button title={t`manageRollover.contactUs`} clickHandler={() => window.open(feedbackUrl, '_blank')} hideThreeEssentialsIcon />
            </ContentWrapper>
        </Container>
    );
};
